import { useEffect, useRef } from 'react';

/**
 * Igual ao useEffect, mas não roda na montagem: só quando alguma dependência muda depois.
 * Útil quando outro efeito já faz a carga inicial e este só deve reagir a mudanças.
 */
function useUpdateEffect(effect, deps) {
    const isMounted = useRef(false);

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return undefined;
        }
        return effect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    // Em StrictMode o React desmonta e remonta em desenvolvimento; volta ao estado inicial
    useEffect(() => () => { isMounted.current = false; }, []);
}

export default useUpdateEffect;
